import React from 'react';
import { Button } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const ChatButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/chat'); // Navigate to the chat screen
  };

  return (
    <Button
      type="primary"
      shape="circle"
      icon={<MessageOutlined />}
      size="large"
      style={{
        position: 'fixed',
        bottom: '30px',
        right: '24px',
        zIndex: 1000,
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      }}
      onClick={handleClick}
    />
  );
};

export default ChatButton;
